#import "../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
query AttachableSupplierDocuments(
  $first: Int
  $after: Cursor
  $supplierId: UUID!
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachableSupplierDocuments(
    first: $first
    after: $after
    documentTypeId: $documentTypeId
    orderBy: $orderBy
    filter: $filter
    supplierId: $supplierId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
